export default __webpack_public_path__ + "static/media/Nemh.a75287c6.jpg";